import { render, staticRenderFns } from "./OtherLabourListSideMenu.vue?vue&type=template&id=d08b8e9c&scoped=true"
import script from "./OtherLabourListSideMenu.vue?vue&type=script&lang=js"
export * from "./OtherLabourListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OtherLabourListSideMenu.vue?vue&type=style&index=0&id=d08b8e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08b8e9c",
  null
  
)

export default component.exports